/* import __COLOCATED_TEMPLATE__ from './templates-modal-button.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */

import Component from '@glimmer/component';
import type Guideline from 'embercom/models/ai-agent/guidelines';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';
import type AiAgentGuidelineService from 'embercom/services/ai-agent-guideline-service';
import type { GuidelineExample } from 'embercom/services/ai-agent-guideline-service';
export interface Args {
  guideline: Guideline;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

export default class TemplatesModalButton extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare aiAgentGuidelineService: AiAgentGuidelineService;
  @tracked showModal = false;

  get guidelineExamples(): GuidelineExample[] {
    if (this.args.guideline.category === 'other') {
      return [];
    }
    return this.aiAgentGuidelineService.guidelineExamples(this.args.guideline.category);
  }

  @action
  editGuideline(example: GuidelineExample) {
    this.aiAgentGuidelineService.setGuidelineFromExample(this.args.guideline, example);
    this.showModal = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Guidance::TemplatesModalButton': typeof TemplatesModalButton;
  }
}
